import { observer } from 'mobx-react-lite'
import { type SingleSelectFilter } from '@/infra/SingleSelectFilter'
import { type InventoryItemTypeFilter } from '@/features/inventory/admin/InventorySearchViewModel'
import { InventoryViewer } from '@/features/inventory/admin/components/InventoryViewer'

export interface InventoryViewerContainerProps<
  TFilters extends Record<string, unknown>,
> {
  filter: SingleSelectFilter<keyof TFilters, InventoryItemTypeFilter>
}

export const InventoryViewerContainer = observer(
  function InventoryViewerContainer<TFilters extends Record<string, unknown>>({
    filter,
  }: InventoryViewerContainerProps<TFilters>) {
    return (
      <InventoryViewer
        title={filter.title}
        selectedTitle={filter.value?.title}
        options={filter.options
          .filter((opt) => opt.value.visible)
          .map((option, index) => {
            const isActive = filter.isSelected(option.value)
            return {
              key: `${option.title}-${index}`,
              title: option.title,
              valueTitle: option.value.title,
              isActive,
              onSelect: () => filter.change(option.value),
            }
          })}
      />
    )
  },
)
